var _path, _g, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 187,
    viewBox: "0 0 118 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4863 45.4463L58.4865 16.7604C58.4865 15.9844 59.332 15.5041 59.9986 15.9015L83.5414 29.9374C83.844 30.1178 84.0294 30.444 84.0294 30.7963V99.4422",
    stroke: "#FF6F61",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_10181_19900)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.2435,
    cy: 45.7452,
    r: 14.3655,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.384 45.745C68.384 50.7938 64.2911 54.8867 59.2423 54.8867C54.1935 54.8867 50.1006 50.7938 50.1006 45.745C50.1006 40.6962 54.1935 36.6033 59.2423 36.6033C60.1794 36.6033 61.0835 36.7443 61.9347 37.0062C60.3476 37.7229 59.2431 39.3195 59.2431 41.1741C59.2431 43.6985 61.2895 45.745 63.8139 45.745C65.6682 45.745 67.2647 44.6408 67.9815 43.054C68.2432 43.9048 68.384 44.8084 68.384 45.745ZM60.549 48.3568C61.2703 48.3568 61.855 47.7721 61.855 47.0509C61.855 46.3296 61.2703 45.7449 60.549 45.7449C59.8278 45.7449 59.2431 46.3296 59.2431 47.0509C59.2431 47.7721 59.8278 48.3568 60.549 48.3568Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 147.335V95.384C8 95.0325 8.18456 94.7068 8.4861 94.5261L58.2595 64.709C58.5752 64.5199 58.9693 64.5195 59.2854 64.7079L109.317 94.5265C109.619 94.7068 109.805 95.0331 109.805 95.3855V147.177C109.805 147.528 109.62 147.853 109.319 148.034L107.051 149.394L94.1225 141.54C93.8052 141.348 93.4072 141.346 93.0888 141.537L64.0421 158.965C63.4396 159.327 63.071 159.978 63.071 160.68V175.762L59.2801 178.035C58.9635 178.225 58.5682 178.225 58.2516 178.035L54.4955 175.783V160.602C54.4955 159.897 54.1246 159.245 53.5191 158.884L24.5821 141.645C24.2653 141.456 23.8704 141.457 23.5545 141.647L10.5872 149.453L8.48572 148.193C8.18439 148.012 8 147.686 8 147.335ZM63.0311 77.265V96.4017C63.0311 97.1043 63.3998 97.7554 64.0023 98.1168L76.8164 105.803L76.8377 86.6811C76.8385 85.9776 76.4697 85.3255 75.8665 84.9637L63.0311 77.265ZM86.0457 105.674L98.2461 98.4096L86.0457 91.0822V105.674ZM100.153 119.805L100.153 107.648L89.973 113.719L100.153 119.805ZM86.0636 136.477V116.198C86.0636 115.808 86.4859 115.567 86.819 115.768C88.8058 116.969 94.3376 120.316 98.887 123.092C99.9143 123.719 100.159 124.656 100.159 125.486C100.159 126.317 100.15 128.113 98.887 128.807C94.1503 131.744 86.0636 136.477 86.0636 136.477ZM76.9236 140.81L76.8305 121.582L64.0025 129.251C63.3986 129.612 63.0288 130.264 63.0288 130.968L63.0289 150.301L75.9538 142.534C76.5585 142.171 76.927 141.516 76.9236 140.81ZM54.4882 77.3295V96.4662C54.4882 97.1688 54.1195 97.8199 53.517 98.1813L40.7029 105.868L40.6816 86.7455C40.6808 86.0421 41.0496 85.39 41.6528 85.0281L54.4882 77.3295ZM31.4736 105.739L19.2732 98.474L31.4736 91.1467V105.739ZM17.3663 119.87L17.3667 107.712L27.5463 113.784L17.3663 119.87ZM31.4557 136.542V116.262C31.4557 115.873 31.0334 115.631 30.7002 115.833C28.7135 117.034 23.1817 120.381 18.6323 123.157C17.605 123.784 17.3606 124.72 17.3606 125.551C17.3606 126.381 17.3692 128.177 18.6323 128.872C23.369 131.809 31.4557 136.542 31.4557 136.542ZM40.5957 140.875L40.6888 121.647L53.5168 129.316C54.1207 129.677 54.4905 130.329 54.4905 131.032L54.4904 150.366L41.5655 142.598C40.9608 142.235 40.5923 141.58 40.5957 140.875ZM41.01 111.431L58.7818 122.102L76.5439 111.451C77.1909 111.063 77.1916 110.125 76.5452 109.736L59.3074 99.364C58.9907 99.1734 58.5947 99.1731 58.2776 99.3631L41.0106 109.716C40.3631 110.104 40.3628 111.042 41.01 111.431Z",
    fill: "#1ABC9C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10181_19900",
    x: 10.8779,
    y: 0.779638,
    width: 96.7314,
    height: 96.7312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10181_19900"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.427451 0 0 0 0 0.372549 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10181_19900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10181_19900",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10181_19900"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.5509c67f06f0af5879f4555a70cf5318.svg";
export { ForwardRef as ReactComponent };